if (!customElements.get('sons-garment-builder')) {
  customElements.define('sons-garment-builder', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-builder-form]');
      this.products = JSON.parse(this.querySelector('[data-products]').textContent);
      this.cut = this.querySelector('[data-cut]');
      this.color = this.querySelector('[data-color]');
      this.size = this.querySelector('[data-size]');
      this.search = this.querySelector('[data-search]');
      this.designDialog = this.querySelector('[data-design-dialog]');
      this.logoOnlyDialog = this.querySelector('[data-logo-only-dialog]');
      this.logoOnlyConfirmed = false;
      this.error = this.querySelector('[data-error]');
      this.submitButton = this.querySelector('[data-submit]');
      this.shortProduct = null;
      this.shortRequest = 0;
      this.previewRequest = 0;
      this.previewDesign = null;
      this.previewGalleryImage = null;
      this.gallerySelecting = false;
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onGalleryClick = this.onGalleryClick.bind(this);
      this.onDesignDialogClick = this.onDesignDialogClick.bind(this);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onGalleryClick);
      this.addEventListener('click', this.onDesignDialogClick);
      this.onSearch = () => this.filterDesigns();
      this.search.addEventListener('input', this.onSearch);
      this.update();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onGalleryClick);
      this.removeEventListener('click', this.onDesignDialogClick);
      this.search?.removeEventListener('input', this.onSearch);
    }

    get garment() { return this.dataset.fixedGarment || this.form.elements.garment.value; }
    get design() { return this.querySelector('input[name="design"]:checked'); }
    get basic() { return this.dataset.fixedLine === 'basic' || this.design?.dataset.basic === 'true'; }
    get frontDesignOnly() { return this.querySelector('input[name="logo"]:checked')?.value === 'Diseño delantero'; }
    get root() { return this.dataset.root.replace(/\/?$/, '/'); }
    get productKey() { return this.garment === 'short' ? 'short' : `${this.garment}_${this.basic ? 'basic' : 'story'}`; }
    get isDemo() { return this.dataset.demo === 'true'; }

    demoVariants() {
      if (this.garment === 'tank') {
        const sizes = {Unisex: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'], Hombre: ['S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'], Mujer: ['XS', 'S', 'M', 'L', 'XL', 'XXL']};
        const colors = {Unisex: ['Blanco', 'Negro', 'Gris mezcla', 'Melocotón', 'Azul ártico'], Hombre: ['Blanco', 'Negro', 'Gris mezcla', 'Limón', 'Naranja', 'Rojo', 'Azul atolón', 'Azul royal', 'French marino'], Mujer: ['Blanco', 'Negro']};
        return Object.keys(sizes).flatMap(cut => colors[cut].flatMap(color => sizes[cut].map(size => ({cut, color, size, available: true, price: this.basic ? 1600 : 2000}))));
      }
      const isSweat = this.garment === 'sweat';
      const cuts = isSweat ? ['Unisex', 'Niño/a'] : ['Hombre', 'Mujer', 'Niño/a'];
      const adultColors = isSweat ? ['Blanco', 'Negro', 'Rojo', 'Navy', 'Arena'] : this.garment === 'long' ? ['Blanco', 'Negro', 'Rojo', 'Navy', 'Caqui', 'Antracita'] : ['Blanco', 'Negro', 'Rojo', 'Navy', 'Arena', 'Caqui'];
      const sizes = cut => cut === 'Niño/a' ? (this.garment === 'short' ? ['2 años', '4 años', '6 años', '8 años', '10 años', '12 años'] : ['4 años', '6 años', '8 años', '10 años', '12 años']) : cut === 'Mujer' ? ['S', 'M', 'L', 'XL', 'XXL'] : ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
      const price = this.garment === 'short' ? Number(this.design?.dataset.demoPrice) || null : this.garment === 'long' ? (this.basic ? 3300 : 4000) : (this.basic ? 3800 : 4500);
      return cuts.flatMap(cut => (cut === 'Niño/a' ? ['Blanco', 'Negro', 'Rojo', 'Navy'] : adultColors).flatMap(color => sizes(cut).map(size => ({cut, color, size, available: true, price}))));
    }

    onDesignDialogClick(event) {
      if (event.target.closest('[data-open-designs]')) {
        this.designDialog?.showModal();
        this.search?.focus();
      } else if (event.target.closest('[data-close-designs]') || event.target === this.designDialog) {
        this.designDialog?.close();
      } else if (event.target.closest('[data-select-rear-design]')) {
        this.logoOnlyDialog?.close();
        this.querySelector('[data-open-designs]')?.click();
      } else if (event.target.closest('[data-confirm-logo-only]')) {
        this.logoOnlyDialog?.close();
        this.logoOnlyConfirmed = true;
        this.onSubmit(new Event('submit', {cancelable: true}));
      } else if (event.target.closest('[data-remove-design]')) {
        this.design.checked = false;
        this.logoOnlyConfirmed = false;
        this.previewDesign = null;
        this.previewGalleryImage = null;
        this.shortProduct = null;
        ++this.shortRequest;
        this.update();
      }
    }

    onGalleryClick(event) {
      const button = event.target.closest('[data-choose-design]');
      if (!button || !this.contains(button)) return;
      const input = [...this.querySelectorAll('input[name="design"]')].find(option => option.value === button.dataset.chooseDesign);
      if (!input) return;
      this.search.value = '';
      this.filterDesigns();
      input.checked = true;
      this.logoOnlyConfirmed = false;
      this.previewDesign = button.dataset.previewProduct === input.value ? null : button.dataset.previewProduct;
      this.previewGalleryImage = button.closest('.soc-builder__gallery-card')?.querySelector('.soc-builder__gallery-image')?.src || null;
      this.gallerySelecting = true;
      input.dispatchEvent(new Event('change', {bubbles: true}));
      this.gallerySelecting = false;
      this.error.hidden = true;
      this.designDialog?.close();
      this.querySelector('[data-open-designs]')?.focus({preventScroll: true});
    }

    onChange(event) {
      if (event.target.name === 'garment') {
        this.cut.value = '';
        this.color.value = '';
        this.size.value = '';
        this.logoOnlyConfirmed = false;
      }
      if (event.target === this.cut || event.target === this.color || event.target === this.size || event.target.name === 'logo') this.logoOnlyConfirmed = false;
      if (event.target === this.cut) {
        this.size.value = '';
      }
      if (event.target === this.color) this.size.value = '';
      if (event.target.name === 'design' && !this.gallerySelecting) {
        this.previewDesign = null;
        this.previewGalleryImage = null;
        this.logoOnlyConfirmed = false;
      }
      this.update();
      if (event.target.name === 'design' || event.target.name === 'garment') this.loadShortProduct();
    }

    async loadShortProduct() {
      const request = ++this.shortRequest;
      this.shortProduct = null;
      if (this.isDemo || this.garment !== 'short' || !this.design || this.basic) return;
      this.submitButton.disabled = true;
      try {
        const response = await fetch(`${this.root}products/${encodeURIComponent(this.design.value)}.js`, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('No se pudo consultar la camiseta seleccionada.');
        const product = await response.json();
        if (request !== this.shortRequest || this.garment !== 'short' || this.design?.value !== product.handle) return;
        const names = product.options.map(option => typeof option === 'string' ? option : option.name);
        const index = name => names.findIndex(option => option.toLocaleLowerCase('es') === name);
        if (['corte', 'color', 'talla'].some(name => index(name) === -1)) throw new Error('Las opciones de la camiseta no están configuradas como Corte, Color y Talla.');
        this.shortProduct = {variants: product.variants.map(variant => ({
          id: variant.id, cut: variant.options[index('corte')], color: variant.options[index('color')],
          size: variant.options[index('talla')], available: variant.available, price: variant.price,
          image: variant.featured_image?.src || null,
        }))};
        this.update();
      } catch (error) {
        if (request !== this.shortRequest) return;
        this.error.textContent = error.message;
        this.error.hidden = false;
      }
    }

    options(select, values, placeholder) {
      const previous = select.value;
      select.replaceChildren(new Option(placeholder, ''));
      values.forEach(value => select.add(new Option(value, value)));
      select.value = values.includes(previous) ? previous : '';
    }

    update() {
      const product = this.garment === 'short' ? this.shortProduct : this.products[this.design || this.dataset.fixedLine ? this.productKey : `${this.garment}_basic`];
      // Antes de elegir un diseño, ofrecer opciones orientativas para poder personalizar la prenda primero.
      // Al seleccionar el diseño, las variantes reales sustituyen estas opciones; nunca se venden las orientativas.
      const variants = (this.isDemo && !this.dataset.fixedGarment || this.garment === 'short' && !this.design || this.garment === 'tank' && !product?.variants?.length && !this.dataset.fixedGarment ? this.demoVariants() : product?.variants || []).filter(variant => variant.available);
      this.options(this.cut, [...new Set(variants.map(v => v.cut).filter(Boolean))], 'Selecciona un corte');
      if (!this.cut.value) this.cut.value = this.garment === 'sweat' && [...this.cut.options].some(option => option.value === 'Unisex') ? 'Unisex' : [...this.cut.options].some(option => option.value === 'Hombre') ? 'Hombre' : this.cut.options[1]?.value || '';
      const colors = [...new Set(variants.filter(v => v.cut === this.cut.value).map(v => v.color).filter(Boolean))];
      this.options(this.color, colors, 'Selecciona un color');
      if (!this.color.value) {
        const previewColor = {short: 'Negro', long: 'Antracita', sweat: 'Rojo', tank: 'Negro'}[this.garment];
        this.color.value = colors.find(color => color.localeCompare(previewColor, 'es', {sensitivity: 'base'}) === 0) || colors[0] || '';
      }
      const sizes = [...new Set(variants.filter(v => v.cut === this.cut.value && v.color === this.color.value).map(v => v.size).filter(Boolean))];
      this.options(this.size, sizes, 'Selecciona una talla');
      if (!this.size.value) {
        const order = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
        this.size.value = sizes.slice().sort((a, b) => {
          const rank = size => order.includes(size) ? order.indexOf(size) : /^\d+/.test(size) ? Number.parseInt(size, 10) : 100;
          return rank(a) - rank(b);
        })[0] || '';
      }
      this.variant = variants.find(v => v.cut === this.cut.value && v.color === this.color.value && v.size === this.size.value);

      this.querySelectorAll('[data-guide]').forEach(guide => {
        guide.hidden = guide.dataset.guide !== this.garment;
        const active = guide.querySelector(`[data-size-panel="${this.cut.value === 'Niño/a' ? 'nino' : this.cut.value.toLowerCase()}"]`);
        if (active && !guide.hidden) this.activateGuide(guide, active.dataset.sizePanel);
      });

      const logoOptions = [...this.querySelectorAll('input[name="logo"]')];
      const frontDesignOption = logoOptions.find(option => option.value === 'Diseño delantero');
      if (frontDesignOption) {
        // La camiseta corta utiliza el producto ya estampado: no podemos prometer
        // diseño exclusivamente delantero sin una base específica sin imprimir.
        const canPrintOnFront = !!this.design && !this.basic && this.garment !== 'short';
        frontDesignOption.closest('label').hidden = !canPrintOnFront;
        if (frontDesignOption.checked && !canPrintOnFront) frontDesignOption.checked = false;
      }
      const tankBack = this.querySelector('[data-tank-back]');
      tankBack.hidden = this.garment !== 'tank';
      tankBack.textContent = this.garment === 'tank' ? this.cut.value === 'Mujer' ? 'Espalda de nadadora.' : 'Espalda ancha.' : '';
      this.querySelector('[data-tank-unavailable]').hidden = this.garment !== 'tank' || this.isDemo || !!product?.variants?.length;
      this.querySelector('[data-basic-notice]').hidden = !(this.basic && this.garment === 'short');
      this.querySelector('[data-logo-missing]').hidden = logoOptions.length > 0;
      logoOptions.forEach(option => { option.required = true; option.disabled = false; });

      const image = this.querySelector('[data-preview-image]');
      const selectedDesign = this.querySelector('[data-selected-design]');
      selectedDesign.hidden = !this.design;
      selectedDesign.textContent = this.design ? `Diseño elegido: ${this.design.dataset.designName}` : '';
      this.querySelector('[data-remove-design]').hidden = !this.design;
      this.querySelectorAll('[data-choose-design]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.chooseDesign === this.design?.value));
      });
      this.updatePreview(image, variants);
      const label = this.dataset.fixedGarment ? this.garment === 'tank' ? 'Tirantes' : this.garment === 'sweat' ? 'Sudadera' : 'Manga larga' : this.querySelector(`input[name="garment"]:checked`)?.nextElementSibling?.textContent || '';
      const chosenLogo = this.querySelector('input[name="logo"]:checked')?.value;
      const parts = [label, this.basic ? 'Logo delantero' : this.design?.dataset.designName, this.cut.value, this.color.value, this.size.value, this.frontDesignOnly ? 'Diseño solo delantero' : chosenLogo].filter(Boolean);
      this.querySelector('[data-summary]').textContent = parts.length > 1 ? parts.join(' · ') : 'Personaliza tu prenda.';
      const price = this.variant?.price != null && (this.design || this.garment !== 'short') ? new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {style: 'currency', currency: this.dataset.currency}).format(this.variant.price / 100) : '';
      this.submitButton.disabled = this.isDemo || this.dataset.enabled !== 'true' || !this.variant?.id || !chosenLogo || (this.dataset.fixedLine === 'story' && (!this.design || this.basic)) || (this.garment === 'tank' && !product?.variants?.length) || (this.garment === 'short' && !!this.design && this.basic);
      this.querySelector('[data-price]').textContent = price;
      this.querySelector('[data-button-price]').textContent = this.isDemo ? '' : price;
    }

    async updatePreview(image, variants) {
      const request = ++this.previewRequest;
      const fallbackImages = {
        short: this.querySelector('[data-preview-image]')?.parentElement.dataset.basicBlack,
        long: 'https://sons-of-camper.vercel.app/assets/images/blancs/ml_a_antracita.jpg',
        sweat: 'https://sons-of-camper.vercel.app/assets/images/blancs/sudadera_a_rojo.jpg',
        tank: 'https://s7g3.scene7.com/is/image/soloinvest/n03980102A?wid=800&hei=1000&fmt=webp',
      };
      const sampleColors = {short: 'Negro', long: 'Antracita', sweat: 'Rojo'};
      const selectedColor = this.color.value || sampleColors[this.garment];
      const normalized = value => value?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const matching = variants.find(v => normalized(v.color) === normalized(selectedColor) && (!this.cut.value || v.cut === this.cut.value) && v.image);
      let url = matching?.image;
      if (this.garment === 'short' && !this.design && this.color.value) {
        const sample = {negro: 'negra', blanco: 'blanco', rojo: 'roja', navy: 'navy', arena: 'arena', caqui: 'caqui'}[normalized(selectedColor)];
        if (sample) url = `https://sons-of-camper.vercel.app/assets/images/products/camiseta-basic_${sample}.webp`;
      }
      if (!url && this.garment !== 'short' && this.garment !== 'tank') {
        const path = this.garment === 'long' ? 'ml_a_' : 'sudadera_a_';
        const color = {negro: 'negro', blanco: 'blanco', rojo: 'rojo', navy: 'navy', arena: 'arena', caqui: 'caqui', antracita: 'antracita'}[normalized(selectedColor)];
        if (color && (this.garment !== 'long' || color !== 'arena') && (this.garment !== 'sweat' || color !== 'caqui')) url = `https://sons-of-camper.vercel.app/assets/images/blancs/${path}${color}.jpg`;
      }
      if (this.garment === 'tank') {
        const model = {Unisex: '03980', Hombre: '11465', Mujer: '01826'}[this.cut.value];
        const colorCode = {Blanco: '102', Negro: '309', 'Gris mezcla': '350', Melocotón: '409', 'Azul ártico': '199', 'French marino': '319', Limón: '302', Naranja: '400', Rojo: '145', 'Azul atolón': '225', 'Azul royal': '241'}[selectedColor];
        url = matching?.image || (model && colorCode ? `https://s7g3.scene7.com/is/image/soloinvest/n${model}${colorCode}A?wid=800&hei=1000&fmt=webp` : fallbackImages.tank);
      }
      if (this.garment === 'short' && this.previewGalleryImage && this.basic) url = this.previewGalleryImage;
      if (!url && this.garment === 'short' && this.design?.dataset.image) url = this.design.dataset.image;
      if (!url && this.garment === 'short') url = this.querySelector('[data-preview-image]').parentElement.dataset.basicBlack;
      if (!url) url = fallbackImages[this.garment];
      // For a chosen story design, the product's colour variant provides the actual printed preview.
      if (this.garment === 'short' && this.design && (!matching?.image || this.basic && this.previewDesign)) {
        try {
          const handle = this.previewDesign || this.design.value;
          const product = await (await fetch(`${this.root}products/${encodeURIComponent(handle)}.js`, {credentials: 'same-origin'})).json();
          if (request !== this.previewRequest) return;
          const match = product.variants.find(v => normalized(v.option2) === normalized(selectedColor) && v.featured_image?.src);
          url = match?.featured_image?.src || url;
        } catch (_) { /* Keep the source image if the colour image cannot be loaded. */ }
      }
      if (request !== this.previewRequest) return;
      const source = this.querySelector('[data-source-design]');
      const showSource = !!this.design && this.garment !== 'short';
      source.hidden = !showSource;
      if (showSource) {
        const sourceImage = this.previewGalleryImage || this.design.dataset.image;
        source.querySelector('[data-source-image]').src = sourceImage;
        source.querySelector('[data-source-label]').textContent = this.basic ? 'Logo delantero elegido' : `Diseño: ${this.design.dataset.designName}`;
      }
      image.hidden = !url;
      this.querySelector('[data-preview-placeholder]').hidden = !!url;
      if (url && image.src !== url) image.src = url;
      image.alt = this.design && this.garment === 'short' ? `Camiseta con diseño ${this.design.dataset.designName}, color ${selectedColor}` : `${this.querySelector('input[name="garment"]:checked')?.nextElementSibling?.textContent || 'Prenda'}, color ${selectedColor}`;
      this.querySelector('[data-preview-note]').textContent = this.garment === 'short' && this.design && !this.basic
        ? 'Imagen de la camiseta original del diseño y color seleccionado, si está disponible.'
        : 'Imagen orientativa de la prenda y el color; no es un montaje del diseño final.';
    }

    activateGuide(guide, cut) {
      guide.querySelectorAll('[data-size-panel]').forEach(panel => { panel.hidden = panel.dataset.sizePanel !== cut; });
      guide.querySelectorAll('[data-size-tab]').forEach(tab => {
        const active = tab.dataset.sizeTab === cut;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
    }

    filterDesigns() {
      const normalize = value => value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es');
      const query = normalize(this.search.value);
      let visible = 0;
      this.querySelectorAll('.soc-builder__gallery-card').forEach(card => {
        card.hidden = !normalize(card.querySelector('h3').textContent).includes(query);
        if (!card.hidden) visible++;
      });
      this.querySelector('[data-no-design]').hidden = visible > 0;
    }

    async onSubmit(event) {
      event.preventDefault();
      this.error.hidden = true;
      if (this.isDemo || this.dataset.enabled !== 'true') return;
      if (!this.variant?.id || !this.querySelector('input[name="logo"]:checked') || (this.dataset.fixedLine === 'story' && (!this.design || this.basic)) || (this.basic && this.garment === 'short') || this.frontDesignOnly && (!this.design || this.basic || this.garment === 'short')) {
        this.error.textContent = this.basic && this.garment === 'short'
          ? 'Logo delantero en manga corta aún no tiene una camiseta base sin estampar. Elige manga larga o sudadera.'
          : 'Selecciona un corte, color, talla y logo delantero para continuar.';
        this.error.hidden = false;
        return;
      }
      if (!this.design && this.garment === 'short' && this.logoOnlyConfirmed) {
        this.error.textContent = 'Para una camiseta de manga corta solo con logo delantero aún no existe una base sin estampar. Elige manga larga o sudadera, o selecciona un diseño trasero.';
        this.error.hidden = false;
        return;
      }
      if (!this.design && this.dataset.fixedLine !== 'basic' && !this.logoOnlyConfirmed) {
        this.logoOnlyDialog.showModal();
        return;
      }
      const chosenLogo = this.querySelector('input[name="logo"]:checked').value;
      const properties = {
        'Prenda': this.dataset.fixedGarment ? this.garment === 'tank' ? 'Tirantes' : this.garment === 'sweat' ? 'Sudadera' : 'Manga larga' : this.querySelector('input[name="garment"]:checked').nextElementSibling.textContent,
      };
      if (this.frontDesignOnly) properties['Posición del diseño'] = 'Solo en la parte delantera';
      else {
        properties['Logo frontal'] = chosenLogo;
        if (this.design && !this.basic && this.garment !== 'short') properties['Posición del diseño'] = 'Parte trasera, con logo delantero';
      }
      if (this.garment === 'tank') properties['Espalda'] = this.cut.value === 'Mujer' ? 'Espalda de nadadora' : 'Espalda ancha';
      if (this.design && !this.basic) {
        properties['Diseño'] = this.design.dataset.designName;
        properties['Referencia del diseño'] = this.design.value;
      }
      this.submitButton.disabled = true;
      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: this.variant.id, quantity: 1, properties}]}),
        });
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || 'No se pudo añadir la prenda al carrito.');
        }
        // Evita el salto automático por Shop Pay: algunas sesiones muestran una pantalla vacía
        // antes de llegar al checkout. Shop Pay sigue disponible dentro del checkout nativo.
        window.location.assign(`${this.root}checkout?skip_shop_pay=true`);
      } catch (error) {
        this.error.textContent = error.message || 'No se pudo continuar al pago. Inténtalo de nuevo.';
        this.error.hidden = false;
        this.submitButton.disabled = false;
      }
    }
  });
}

document.addEventListener('click', event => {
  const tab = event.target.closest('sons-garment-builder [data-size-tab]');
  if (!tab) return;
  const guide = tab.closest('[data-guide]');
  guide.closest('sons-garment-builder').activateGuide(guide, tab.dataset.sizeTab);
});
